import { Component, OnInit } from '@angular/core';
import { authCheck, authLogout } from '@core/auth/store/auth.actions';
import { selectIsAuthenticated } from '@core/auth/store/auth.selectors';
import { AppState } from '@core/core.state';
import { Store } from '@ngrx/store';
import { StoreDevtools } from '@ngrx/store-devtools';
import { TranslateService } from '@ngx-translate/core';
import { IconLibraryService } from '@shared/icons.library';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { MirageService } from '../mock/mirage.service';
import { selectAuthorities } from '@core/auth/store/auth.selectors';
import { map } from 'rxjs/operators';
import { Authority, checkAdminRole } from '@core/auth/auth.model';

@Component({
  selector: 'wa-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  navigation = [{ link: 'researches', label: 'theme.researches' }];

  isAuthenticated$ = this.store
    .select(selectAuthorities)
    .pipe(map((authorities?: Authority[]) => checkAdminRole(authorities)));

  constructor(
    private store: Store<AppState>,
    private storeDevtools: StoreDevtools,
    private translateService: TranslateService,
    private iconLibraryService: IconLibraryService,
    private mirageService: MirageService
  ) {
    this.iconLibraryService.registryIcon();
  }

  ngOnInit(): void {
    if (environment.mock) {
      this.mirageService.startServer();
    }
    this.translateService.setDefaultLang('en');
    this.translateService.use('en');
    this.store.dispatch(authCheck());
  }

  logout(): void {
    this.store.dispatch(authLogout());
  }
}
